import { formatDateYMDToDMY } from "utils";
import toCurrency from "utils/toCurrency";

import {
  currencyField,
  dateField,
  externalLinkField,
  readOnlyField,
  textField,
} from "../fieldBuilders";

const formatEstimatedValue = (opportunity) =>
  opportunity.estimatedValue ? toCurrency(opportunity.estimatedValue) : "-";

const buildEBuyGroups = ({
  opportunity,
  formData,
  onChangeValue,
  focusField,
  defaultCurrencyCode,
}) => {
  const isEstimatedValueEditable = !opportunity.estimatedValueIsFromSource;

  const estimatedValueField = isEstimatedValueEditable
    ? currencyField("estimatedValue", "Amount", formData, onChangeValue, {
        currencyCode: defaultCurrencyCode,
        autoFocus: focusField === "estimatedValue",
      })
    : readOnlyField("estimatedValue", "Amount", formatEstimatedValue(opportunity));

  return [
    {
      title: "Fully Editable",
      fields: [
        ...(isEstimatedValueEditable ? [estimatedValueField] : []),
        externalLinkField(formData, onChangeValue),
        textField("upiid", "Reference # / uPIID", formData, onChangeValue, {
          placeholder: "Reference # / uPIID",
        }),
        textField("naicsCode", "NAICS", formData, onChangeValue, {
          placeholder: "NAICS code",
        }),
        textField(
          "followOnRequirement",
          "Follow On Requirement",
          formData,
          onChangeValue,
          { placeholder: "Follow on requirement" }
        ),
        textField(
          "previousRfiInformation",
          "Previous RFI Information",
          formData,
          onChangeValue,
          { placeholder: "Previous RFI information" }
        ),
        textField("contractType", "Contract Type", formData, onChangeValue, {
          placeholder: "Contract type",
        }),
        textField("delivery", "Delivery", formData, onChangeValue, {
          placeholder: "Delivery",
        }),
        textField("awardMethod", "Award Method", formData, onChangeValue, {
          placeholder: "Award method",
        }),
        textField("category", "Category(s)", formData, onChangeValue, {
          placeholder: "Category",
        }),
        textField("contactName", "Contact Name", formData, onChangeValue, {
          placeholder: "Contact name",
        }),
        textField("contactEmail", "Contact Email", formData, onChangeValue, {
          placeholder: "Contact email",
        }),
        textField("contactPhone", "Contact Phone", formData, onChangeValue, {
          placeholder: "Contact phone",
        }),
        textField(
          "contractVehicle",
          "Contract Vehicle",
          formData,
          onChangeValue,
          {
            placeholder: "Contract vehicle",
          }
        ),
        textField(
          "competitionType",
          "Competition Type",
          formData,
          onChangeValue,
          {
            placeholder: "Competition type",
          }
        ),
        dateField("qaDeadline", "Q&A Deadline", formData, onChangeValue, {
          placeholder: "Q&A deadline",
        }),
      ],
    },
    {
      title: "Synced from eBuy",
      subtitle: "Read only - data extracted from eBuy",
      fields: [
        ...(isEstimatedValueEditable ? [] : [estimatedValueField]),
        readOnlyField(
          "requestId",
          "Solicitation Number",
          opportunity.requestId
        ),
        readOnlyField(
          "vehicleName",
          "Contract Number",
          opportunity.vehicleName
        ),
        readOnlyField("status", "Status", opportunity.status),
        readOnlyField(
          "postedDate",
          "Posted Date",
          formatDateYMDToDMY(opportunity.postedDate)
        ),
        readOnlyField(
          "departmentAgency",
          "Agency",
          opportunity.departmentAgency
        ),
        readOnlyField("subTier", "Sub-Tier", opportunity.subTier),
        readOnlyField(
          "dueDate",
          "Due Date",
          formatDateYMDToDMY(opportunity.dueDate)
        ),
      ],
    },
  ];
};

export default buildEBuyGroups;
